/**
 * Encodes a URL to be used in a link.
 * @param url - The URL to encode.
 * @returns The encoded URL.
 */
export const encodeBaseUrl = (url: string) => {
  return encodeURI(url.toLowerCase());
};
